import { Locale } from '@ps-smart-cp/ppfw-client';

const contractGenerationClassConfig = {
  agreement: new Map([
    [Locale.ja, '約定'],
    [Locale.en, 'Agreement'],
  ]),
  occurrence: new Map([
    [Locale.ja, '発生'],
    [Locale.en, 'Occurrence'],
  ]),
  occurrenceYear: new Map([
    [Locale.ja, '発生(年)'],
    [Locale.en, 'Occurrence Year'],
  ]),
  agreementInterestOccurrence: new Map([
    [Locale.ja, '約定(利息発生)'],
    [Locale.en, 'Agreement Interest Occurrence'],
  ]),
};

export { contractGenerationClassConfig };
